<template>
  <div class="documents-browser">
    <div class="documents-browser-topbar">
      <slot name="topbar-left" />
      <slot name="topbar-center" />
      <slot name="topbar-right" />
    </div>

    <div class="documents-browser-content">
      <div v-if="$slots['details-left'] || $slots['details-right']" class="details">
        <slot name="details-left" />
        <slot name="details-right" />
      </div>

      <div v-if="$slots['search']" class="search">
        <slot name="search" />
      </div>

      <div v-if="$slots['assets']" class="assets">
        <slot name="assets" />
      </div>
    </div>
  </div>
</template>

<script setup></script>

<style lang="scss" scoped>
.documents-browser {
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  background: $bb-neutral-0;

  .documents-browser-topbar {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: $bb-spacing-3;
    border-bottom: 1px solid $bb-neutral-5;
    padding: 0 $bb-spacing-3;
  }

  .documents-browser-content {
    height: calc(100vh - 60px);
    padding: $bb-spacing-6 $bb-spacing-8;
    display: flex;
    flex-direction: column;

    .details {
      display: flex;
      justify-content: space-between;
      gap: $bb-spacing-3;
      margin-bottom: $bb-spacing-5;
    }

    .search {
      margin-bottom: $bb-spacing-6;
    }

    .assets {
      overflow: hidden;
    }
  }
}
</style>
